/**
 * Fehlercode → uebersetzter Text.
 *
 * Der Fehlercode der API ist die stabile Grenze. Die Oberflaeche bildet ihn
 * auf einen eigenen Text ab und zeigt die Servermeldung nicht an. Damit gibt
 * es genau einen Textbestand je Sprache -- und die Serverseite muss fuer die
 * Mehrsprachigkeit nicht angefasst werden.
 */
import { MIN_PASSWORD_LENGTH } from "@homebase/shared";
import { ApiError } from "../lib/api.ts";
import type { I18n } from "./index.tsx";

export function errorText(i18n: I18n, e: unknown): string {
  if (!(e instanceof ApiError)) return i18n.t("error.unknown");

  if (e.code === "too_many_attempts") {
    // Die Wartezeit steht im `retry-after`-Kopf. Ohne ihn bleibt der Text
    // trotzdem verstaendlich -- er nennt dann eine Minute.
    const minutes = e.retryAfterSec ? Math.max(1, Math.ceil(e.retryAfterSec / 60)) : 1;
    return minutes === 1
      ? i18n.t("error.too_many_attempts_one")
      : i18n.t("error.too_many_attempts", { minutes });
  }

  if (e.code === "weak_password") return i18n.t("error.weak_password", { n: MIN_PASSWORD_LENGTH });

  /*
   * ── EIN TECHNISCHER CODE IST KEINE MELDUNG ──
   *
   * DER BEFUND DER BROWSER-ABNAHME: beim Versuch, „Departed" ohne
   * Carrier-Uebergabe zu speichern, stand da „Unbekannter Fehler.
   * (cn_not_handed_over)". Der Code half dem Benutzer nicht und sagte
   * ihm auch nicht, was zu tun ist.
   *
   * Der Code wird ab hier PROTOKOLLIERT und nicht angezeigt. Wer ihn
   * braucht, findet ihn in der Konsole; wer vor dem Bildschirm sitzt,
   * liest einen Satz.
   *
   * „Unbekannter Fehler" bleibt fuer das, was es sagt: einen Fehler,
   * den HOMEBASE nicht kennt. `verify` ME1 haelt nach, dass jeder
   * Fachcode, den der Kern wirft, einen Text hat -- damit diese
   * Luecke nicht noch einmal erst im Browser auffaellt.
   */
  const text = i18n.tCode("error", e.code, "");
  if (text) return text;
  console.warn("[homebase] unbekannter Fehlercode", e.code);
  return i18n.t("error.unknown");
}
